class CurrentPageData {
  constructor() {
    this.label = null;
  }
}

// A singleton used for storing data about the current page that can be accessed
// from anywhere in our application.
export const currentPageData = new CurrentPageData();
